// removed by extract-text-webpack-plugin
module.exports = {"dropdownclass":"dropdownclass__1anRf","innerwrapper":"innerwrapper__3V7i8","links":"links__1r7HL","dropdownitems":"dropdownitems__2sfMH"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Navbar/Productmenu/ProductsMenu.scss
// module id = 1113
// module chunks = 68